import {useAppDispatch, useAppSelector} from "../hooks";
import {selectFrontingMembers, updateMember} from "../redux/members";
import {Member} from "../api/Models";
import useApi from "../api/useApi";

export default function useFrontLogic() {
  const dispatch = useAppDispatch()
  const frontingMembers = useAppSelector(selectFrontingMembers)
  const { members } = useApi();

  const updateFronts = async (fronts: Member[]) => {
    //get fronts to remove
    const oldFronts = frontingMembers.filter((f) => !fronts.map((nf) => nf.id).includes(f.id))
    console.log('old fronts', oldFronts)

    //get fronts to add
    const newFronts = fronts.filter((f) => !frontingMembers.map((nf) => nf.id).includes(f.id))
    console.log('new fronts', newFronts)

    for (const oldFront of oldFronts) {
      const updatedMember = await members.updateMember(oldFront.id, {
        isFronting: false
      })
      dispatch(updateMember(updatedMember))
    }

    for (const newFront of newFronts) {
      const updatedMember = await members.updateMember(newFront.id, {
        isFronting: true
      })
      dispatch(updateMember(updatedMember))
    }
  }

  return {
    updateFronts
  };
}